/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Component */
import FaqSectionV2 from '@components/Accordions/FaqSectionV2';
import SectionTitle from '@components/Headings/SectionTitle';
import MidContainer from '@Layout/MidContainer';

/* Services  */
/* Styles */

/**
 * Renders Expression Component
 * @param {Object} sectionContent - data for the section from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 */

const PSFaqSection = ({ section, lang, region }) => {
  return (
    <Box
      width={'100%'}
      height="auto"
      p="50px 0"
      px={{
        xl: 'calc((100% - 1112px) / 2)',
        lg: '18px',
        md: '18px',
        sm: '18px',
        base: '18px',
      }}
    >
      <SectionTitle titleObj={section.sectionContent[0]} />
      <MidContainer w="768">
        {section.sectionContent?.map((faq, i) => {
          return (
            i > 0 && (
              <Box mb="18px" key={nanoid(5)}>
                <FaqSectionV2
                  key={nanoid(5)}
                  faqSection={faq}
                  region={region}
                  lang={lang}
                  bgColor="#293B7D"
                />
              </Box>
            )
          );
        })}
      </MidContainer>
    </Box>
  );
};

export default PSFaqSection;
